// usePipelineState — is a job running, decided once. The derivation lives in
// ./pipelineState (pure, tested); this hook only feeds it the live queries so
// every surface words itself off the same value.

import { useSyncProgress } from "./useSyncProgress";
import { useTaxOperationStatus } from "./useTaxOperationStatus";
import {
  derivePipeline,
  hasCompletedCalc,
  pipelineRowLabel,
} from "./pipelineState";

export type { PipelineState } from "./pipelineState";

export const usePipelineState = () => {
  const { data: syncs } = useSyncProgress();
  const { operationStatus } = useTaxOperationStatus();

  const pipeline = derivePipeline(syncs, operationStatus);

  return {
    pipeline,
    busy: pipeline !== "quiet",
    rowLabel: pipelineRowLabel(pipeline),
    hasFigure: hasCompletedCalc(operationStatus),
  };
};
